import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import AppHeader from './layout/AppHeader.jsx';

const NAV = [
  { to: '/procurement/requests', label: 'Purchase Requests' },
  { to: '/procurement/rfqs', label: 'RFQs', perm: ['rfq', 'list'] },
  { to: '/procurement/orders', label: 'Purchase Orders', perm: ['purchase_order', 'list'] },
  { to: '/procurement/receipts', label: 'Goods Receipts', perm: ['goods_receipt', 'list'] },
  { to: '/procurement/inventory', label: 'Inventory', perm: ['stock_level', 'list'] },
  { to: '/procurement/warehouses', label: 'Warehouses', perm: ['warehouse', 'list'] },
  { to: '/procurement/products', label: 'Products', perm: ['product', 'list'] },
  { to: '/procurement/suppliers', label: 'Suppliers', perm: ['vendor_contract', 'list'] },
];

export default function ProcurementShell() {
  const { can, roles } = useAuth();
  const visible = NAV.filter((n) => !n.perm || roles.includes('super_admin') || can(n.perm[0], n.perm[1]));
  return (
    <div className="hr-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Procurement</div>
          <ul>
            {visible.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
